<template>
  <div
    class="placeholder color--dg bg__color--lg padding--24 align--center"
    :style="{ width }"
  >
    <div class="card placeholder__wrapper padding--18">
      <h3 class="title__h3 bold align--left">
        {{ t('consent_placeholder.title') }}
      </h3>

      <p class="margin__t--18 align--left">
        {{ t('consent_placeholder.description_1') }}
      </p>

      <p class="margin__t--18 align--left">
        {{ t('consent_placeholder.description_2') }}
      </p>

      <button
        class="btn btn__size--small btn__color--sec margin__t--18 bold"
        @click="trigger('cookieBarRequested')"
      >
        {{ t('consent_placeholder.btn') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'
import { useConsent } from '@/vendors/consent'

defineProps({
  width: { type: String }
})

const { t } = useI18n()
const { trigger } = useConsent()
</script>


<style lang="scss" scoped>
.placeholder {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: rem(16px);

  &__wrapper {
    width: min(100%, 411px);
  }
}
</style>